import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function AddClub() {
  const navigate = useNavigate();
  const [clubData, setClubData] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    phone_number: "",
    website: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClubData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://lionfish-app-w73zu.ondigitalocean.app/api/myclub/add-club/",
        clubData
      );
      alert("Club added successfully!");
      navigate("/myclub/register/");
    } catch (error) {
      console.error("Add Club Error:", error.response?.data || error.message);
      setError(error.response?.data?.error || "An error occurred.");
    }
  };

  return (
    <div>
      <h1>Add a Club</h1>
      <form onSubmit={handleSubmit}>
        <input name="name" type="text" placeholder="Club Name" onChange={handleChange} required />
        <input name="address" type="text" placeholder="Address" onChange={handleChange} required />
        <input name="city" type="text" placeholder="City" onChange={handleChange} required />
        <input name="state" type="text" placeholder="State" onChange={handleChange} required />
        <input name="zip_code" type="text" placeholder="ZIP Code" onChange={handleChange} required />
        <input name="phone_number" type="text" placeholder="Phone Number" onChange={handleChange} />
        <input name="website" type="url" placeholder="Website" onChange={handleChange} />
        <button type="submit">Add Club</button>
      </form>
      {error && <div style={{ color: "red" }}>{error}</div>}
    </div>
  );
}

export default AddClub;
